import { useContext, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { encryptURL } from 'utils/functions';
import { CcustoContext } from 'contexts/CcustoContext';
import { GridContext } from 'contexts/GridContext';
import { useModal } from 'components/Modals';
import DeleteModal from 'components/Modals/DeleteModal';
import ResumoModal from 'components/Modals/ResumoModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import DataView, { useDataViewFilters } from 'components/DataView';
import getCcustoFilterFields from './filterFields';

const Ccusto = () => {
  const rotina = 'Ccusto';
  const titulo = 'Centro De Custo';
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { openModal, closeModal } = useModal();
  const { deleteGrid, exportPdf, exportXls } = useContext(GridContext);
  const { ccusto, getCcusto, getLoading } = useContext(CcustoContext);

  const filterFields = useMemo(() => getCcustoFilterFields(), []);

  const { applyFilter, filterForm } = useDataViewFilters({
    fields: filterFields,
    searchParams,
    setSearchParams,
    onApply: (props) => loadGrid(props),
  });
  const { getValues } = filterForm;

  const loadGrid = (props = {}) => {
    const filter = props?.filter || getValues();

    closeModal();

    getCcusto({ ...props, rotina, filter });
  };

  const toolbarActions = [
    {
      name: 'Adicionar',
      icon: 'add',
      placement: 'primary',
      action: () => navigate('/app/Tabelas/Ccusto/Manutencao'),
    },
    {
      name: 'Exportar PDF',
      icon: 'file_download',
      action: () =>
        exportPdf({ rotina, filter: getValues(), order: ccusto?.order }),
    },
    {
      name: 'Exportar XLS',
      icon: 'file_download',
      action: () =>
        exportXls({ rotina, filter: getValues(), order: ccusto?.order }),
    },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={ccusto?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', {
                state: { rotina, group, filter: getValues() },
              })
            }
          />
        ),
    },
  ];

  const rowActions = [
    {
      name: 'Editar',
      icon: 'edit',
      action: ({ row: values }) =>
        navigate('/app/Tabelas/Ccusto/Manutencao', {
          state: { values },
        }),
    },
    {
      name: 'Deletar',
      icon: 'delete',
      action: ({ row }) =>
        openModal(
          <DeleteModal
            onSubmit={() =>
              deleteGrid({
                params: { rotina, id: row?.id },
                cb: () => {
                  loadGrid();
                },
              })
            }
          />
        ),
    },
    {
      name: 'Valores',
      icon: 'attach_money',
      action: ({ row }) =>
        navigate(`/app/Tabelas/Ccusto/Valores/${encryptURL(row)}`),
    },
  ];

  return (
    <Container fillHeight>
      <Header
        rotina={rotina}
        titulo={titulo}
        colunas={ccusto?.colunas}
      />
      <Card fillHeight>
        <DataView
          fillHeight
          grid={ccusto}
          filterFields={filterFields}
          filterForm={filterForm}
          onFilter={applyFilter}
          toolbarActions={toolbarActions}
          rowActions={rowActions}
          checkboxSelection
          loading={getLoading}
          loadGrid={loadGrid}
        />
      </Card>
    </Container>
  );
};

export default Ccusto;

